import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { Descriptions, Table, Alert, Spin, Collapse, Tag, Tooltip, Image } from "antd";
import moment from "moment";

import Navbar from "../../../atoms/navbar";
import Footer from "../../../atoms/footer";
import API from "../../../services";
import HeaderFarms from "../../../utils/header_farms";
import { requestToken } from "../../../auth/AuthServices";
import { Report } from "notiflix";

import "./styles.css";
import ApprovalActions from "../../../atoms/approval-actions";
import ApprovalInfo from "../../../atoms/approval-info";

function ViewPPERequest() {

  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {        

        const at = await requestToken();
        const res = await API.PPEView(HeaderFarms(at), id);
        
        setData(res?.data || res);
      } catch (err) {
        console.error(err);
        Report.info("PPE Request", "Sorry, PPE Request not found", "Okay", () => navigate("/ppe/history"));
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [id]);

  const ellipsisCell = (text) => (<Tooltip placement="topLeft" title={text}><span style={{ display: "inline-block", maxWidth: "100%" }}>{text}</span></Tooltip>);

  const columns = [
    // { title: "Aktivitas", dataIndex: "activity", key: "activity", ellipsis: true, render: ellipsisCell, width: 130 },
    // { title: "Jenis Bahaya", dataIndex: "hazard_type", key: "hazard_type", width: 150, ellipsis: true, render: ellipsisCell },
    { title: "Kategori", dataIndex: "category", key: "category", ellipsis: true, render: ellipsisCell, width: 130 },
    { title: "Nama APD", dataIndex: "name", key: "name", ellipsis: true, render: ellipsisCell, width: 130 },
    { title: "Ukuran", dataIndex: "size", key: "size", width: 90, ellipsis: true, render: ellipsisCell },
    { title: "Warna", dataIndex: "options", key: "options", width: 120, ellipsis: true, render: ellipsisCell },
    { title: "Jumlah", dataIndex: "quantity", key: "quantity", width: 80 },
    { title: "Alasan Ganti APD", dataIndex: "reason_replace", key: "reason_replace", ellipsis: true, render: ellipsisCell },
    { title: "Justifikasi APD Khusus", dataIndex: "reason", key: "reason", ellipsis: true, render: ellipsisCell },
  ];

  const status = data?.approval?.status || data?.approval_process_id?.data?.status || data?.status || "Unknown";
  let ribbonColor = "#FF9900";
  switch (status) {
    case "Approved":
      ribbonColor = "blue";
      break;
    case "Reject":
    case "Rejected":
      ribbonColor = "red";
      break;
    case "Closed":
      ribbonColor = "green";
      break;
    default:
      ribbonColor = "#FF9900";
  }

  return (
    <>
      <Navbar title="PPE Request" subtitle="Details" back={true} navigate="/ppe/history" />
      <div className="container white-back-cr" style={{ minHeight: 500 }}>
        <div className="container mt-3 p-3">
          {loading ? (
            <div className="mt-5 d-flex justify-content-center">
              <Spin />
            </div>
          ) : data ? (
            <>
              <Collapse defaultActiveKey={["1", data?.attachment ? "2" : null].filter(Boolean)}>
                <Collapse.Panel header={<b>PPE Request Detail</b>} key="1">
                  <Descriptions bordered size="small" column={1}>
                    <Descriptions.Item label="Record ID">{data?.record_id || data?.id_record || data?._id || "-"}</Descriptions.Item>
                    <Descriptions.Item label="Employee Name">{data?.employee_name || "-"}</Descriptions.Item>
                    <Descriptions.Item label="Employee ID">{data?.employee_id || "-"}</Descriptions.Item>
                    <Descriptions.Item label="Department">{data?.department || "-"}</Descriptions.Item>
                    <Descriptions.Item label="Submission Type">{data?.submission_type || "-"}</Descriptions.Item>
                    <Descriptions.Item label="Return Date">
                      {data?.return_date ? moment(data.return_date).format("LL") : "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Status">
                      <Tag color={ribbonColor}>{status}</Tag>
                    </Descriptions.Item>
                    <Descriptions.Item label="Description">{data?.description || "-"}</Descriptions.Item>
                    {data?.created_at && (
                      <Descriptions.Item label="Created At">{moment(data.created_at).format("LLL")}</Descriptions.Item>
                    )}
                  </Descriptions>

                  <div className="mt-4">
                    <h6>Items</h6>
                    <Table
                      rowKey={(r, i) => i}
                      pagination={false}
                      columns={columns}
                      dataSource={data?.t_ppe_request_dtl || data?.items || []}
                      scroll={{ x: 700 }}
                    />
                  </div>

                </Collapse.Panel>

                {data?.attachment && (
                  <Collapse.Panel style={{ background: "#e6f7ff" }} header={<b>Attachment</b>} key="2">
                    {data.attachment.startsWith("data:application/pdf") ? (
                      <iframe
                        src={data.attachment}
                        width="100%"
                        height="600px"
                        style={{ border: 'none' }}
                        title="PDF Attachment"
                      />
                    ) : (
                      <Image
                        src={data.attachment}
                        alt="Attachment"
                        width={200}
                        style={{ cursor: 'pointer' }}
                      />
                    )}
                  </Collapse.Panel>
                )}

              </Collapse>
              <ApprovalInfo
                documentData={data}
                activeKeys={['1']}
                onChangeCollapse={() => { }}
              />
            </>
          ) : (
            <Alert type="warning" message="Data not found" />
          )}
        </div>
        <ApprovalActions mainData={data} />
      </div>
      <Footer />
    </>
  );
}

export default ViewPPERequest;


